import React from "react";
import ScreenHeading from "../../utilities/ScreenHeading/ScreenHeading";
import ScrollService from "../../utilities/ScrollService";
import Animations from "../../utilities/Animations";
import "./Skills.css";

export default function Skills(props) {
  let fadeInScreenHandler = (screen) => {
    if (screen.fadeInScreen !== props.id) return;
    Animations.animations.fadeInScreens(props.id);
  };

  // eslint-disable-next-line no-unused-vars
  const fadeInSubscription =
    ScrollService.currentScreenFadeIn.subscribe(fadeInScreenHandler);

  const skillsData = [
    {
      category: "Programming Languages",
      skills: ["Python", "C++", "R", "SQL", "JavaScript"]
    },
    {
      category: "Web Technologies",
      skills: ["HTML", "CSS", "React", "Next.js", "Node.js", "Tailwind CSS", "Bootstrap CSS"]
    },
    {
      category: "Backend & APIs",
      skills: ["FastAPI", "REST APIs", "Uvicorn"]
    },
    {
      category: "Databases",
      skills: ["PostgreSQL", "MongoDB", "SQLite"]
    },
    {
      category: "Computer Science Fundamentals",
      skills: ["Data Structures & Algorithms (C++)", "Object-Oriented Programming (OOPS)", "Database Management Systems (DBMS)","Operating System (OS)", "Computer Network (CN)"]
    },
    {
      category: "Data & AI",
      skills: ["Machine Learning", "Generative AI", "Data Analysis"]
    },
    {
      category: "Developer Tools",
      skills: ["Git", "GitHub", "Postman", "Docker"]
    },
    {
      category: "Soft Skills",
      skills: ["Leadership", "Time Management", "Adaptability", "Teamwork", "Communication", "Critical Thinking", "Creativity"]
    }
  ];

  return (
    <div className="skills-section-container screen-container fade-in" id={props.id || ""}>
      <div className="skills-section-parent">
        <ScreenHeading title={"Skills"} subHeading={"My Technical & Soft Skills"} />
        <div className="skills-content">
          {skillsData.map((skillCategory, index) => (
            <div className="skill-category-section" key={index}>
              <div className="skill-category-header">
                <h3 className="category-name">{skillCategory.category}</h3>
              </div>
              <div className="skills-tags-container">
                {skillCategory.skills.map((skill, skillIndex) => (
                  <div key={skillIndex} className="skill-item">
                    <span className="skill-arrow">➤</span>
                    <span>{skill}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
